import type { PersonInvolvement } from "../types/involvement.js";

/**
 * Where the person was placed at an instant: the name of whoever holds
 * the placement involvement that had started by then and had neither ended nor expired, or
 * `null` where none had.
 */
export const placementNameAt = ({
  involvements,
  at,
}: {
  involvements: readonly Pick<
    PersonInvolvement,
    "kind" | "party" | "startedAt" | "endedAt" | "expiresAt"
  >[];
  at: Date;
}): string | null =>
  involvements.find(
    ({ kind, startedAt, endedAt, expiresAt }) =>
      kind === "placement" &&
      startedAt <= at &&
      (endedAt === null || endedAt > at) &&
      (expiresAt === null || expiresAt > at),
  )?.party.name ?? null;
